<template>
  <div class="detail-form-container position-relative">
    <div v-if="statusCancel==3" class="border border-primary text-primary cancel-card">
      Mẩu tin đã hủy
    </div>
    <b-row>
      <b-col md="8" sm="12">
        <b-row>
          <b-col md="6" sm="12">
            <b-row>
              <b-col md="12" sm="12">
                <b-form-group label="Loại SMS/Notification:" style="font-weight: bold">
                  <div style="font-weight: normal">
                    {{ notiType }}
                  </div>
                </b-form-group>
              </b-col>
              <b-col md="12" sm="12">
                <b-form-group label="Danh mục:" style="font-weight: bold">
                  <div style="font-weight: normal">
                    {{ brand }}
                  </div>
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <b-form-group label="Tiêu đề:" style="font-weight: bold">
                  <div style="font-weight: normal">
                    {{ notifyTitle }}
                  </div>
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <b-form-group label="Nội dung:" style="font-weight: bold">
                  <div style="font-weight: normal">
                    {{ content }}
                  </div>
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <b-form-group label="Mô tả tệp thuê bao:" style="font-weight: bold">
                  <div style="font-weight: normal">
                    {{ description }}
                  </div>
                </b-form-group>
              </b-col>
              <b-col v-if="pycType == 2" cols="12">
                <b-form-group label="Ảnh mô tả" style="font-weight: bold">
                  <img
                      v-if="uploadUrl"
                      :src="uploadUrl"
                      alt="upload-img"
                      class="upload-img"
                  />
                </b-form-group>
              </b-col>
            </b-row>
          </b-col>
          <b-col md="6" sm="12">
            <b-row>
              <b-col md="12" sm="12">
                <b-form-group label="Thời gian bắt đầu:" style="font-weight: bold">
                  <div style="font-weight: normal">
                    {{ startDateShow }}
                  </div>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12" sm="12">
                <b-form-group label="Thời gian kết thúc:" style="font-weight: bold">
                  <div style="font-weight: normal">
                    {{ endDateShow }}
                  </div>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12" sm="12">
                <b-form-group label="Tần suất gửi/Tuần:" style="font-weight: bold">
                  <div style="font-weight: normal">{{ frequency }} lần / tuần</div>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12" sm="12">
                <b-form-group label="Thời điểm gửi trong ngày:" style="font-weight: bold">
                  <div style="font-weight: normal">{{ timeOfDate }}</div>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12" sm="12">
                <b-form-group label="Thời điểm gửi trong tuần:" style="font-weight: bold">
                  <div
                      v-for="(item, index) in dateSend"
                      :key="index"
                      :class="`d-flex ${index !== dateSend.length - 1 ? 'mb-1' : ''}`"
                  >
                    <div style="font-weight: normal">
                      {{ getDate(dateSend[index]) }}
                    </div>
                  </div>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12">
                <b-form-group label="Tệp thuê bao:" style="font-weight: bold">
                  <div class="file-name" @click="downloadFile">file.xslx</div>
                </b-form-group>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import {
  BAvatar,
  BBadge,
  BButton,
  BCard,
  BCardText,
  BCol,
  BDropdown,
  BDropdownItem,
  BFormCheckbox,
  BFormCheckboxGroup,
  BFormDatepicker,
  BFormFile,
  BFormGroup,
  BFormInput,
  BFormRadioGroup,
  BFormSelect,
  BFormTextarea,
  BFormTimepicker,
  BInputGroup,
  BLink,
  BMedia,
  BModal,
  BPagination,
  BRow,
  BTab,
  BTable,
  BTabs,
  BTooltip,
} from "bootstrap-vue";
import Select2 from "v-select2-component";
import FeatherIcon from "@/@core/components/feather-icon/FeatherIcon.vue";
import useJwt from "@/auth/jwt/useJwt";
import {v4 as uuidv4} from "uuid";
import readXlsxFile from "read-excel-file";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import moment from "moment";

export default {
  components: {
    BFormDatepicker,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BTooltip,
    BModal,
    BFormGroup,
    BFormCheckbox,
    BFormSelect,
    BTabs,
    BTab,
    BFormRadioGroup,
    BFormCheckboxGroup,
    BFormTextarea,
    BCardText,
    BInputGroup,
    Select2,
    BFormTimepicker,
    FeatherIcon,
    BFormFile,
  },
  async mounted() {
    await this.getSmsTypeDropdownData(this.pycType);
    await this.getInitDropdownData();

    if (this.initData) {
      this.setData(this.initData);
    }
  },
  props: {
    isAddTemplateBtn: {
      type: Boolean,
      default: false,
    },
    pycType: {
      type: String,
      default: "",
    },
    index: {
      type: Number,
      default: 0,
    },
    campId: {
      type: Number,
      default: 0,
    },
    initData: {
      type: Object,
      default: null,
    },
  },
  computed: {
    inputFileId() {
      return this.inputKey;
    },
    brand() {
      if (this.brands.length === 0) return this.brandName;

      return this.brands.find((item) => item.id === this.brandName)?.text;
    },
    notiType() {
      if (this.smsType.length === 0) return this.type;

      return this.smsType.find((item) => item.id === this.type)?.text;
    },
    startDateShow() {
      if (!this.startDate) return "";

      return moment(this.startDate).format("DD/MM/YYYY");
    },
    endDateShow() {
      if (!this.endDate) return "";

      return moment(this.endDate).format("DD/MM/YYYY");
    },
    timeOfDate() {
      if (!this.sendInDay) return "";

      return moment(this.sendInDay, "HH:mm:SS").format("HH:mm");
    },
  },
  watch: {
    pycType: {
      immediate: true,
      handler(val, oldVal) {
        this.getSmsTypeDropdownData(val);
      },
    },
    frequency: {
      immediate: true,
      handler(val, oldVal) {
        if (val == null || +val < 1) {
          this.frequency = 1;
        } else {
          if (this.dateSend.length > val) {
            this.dateSend = this.dateSend.splice(0, val);
          } else {
            const count = val - this.dateSend.length;
            for (let i = 0; i < count; i++) {
              this.dateSend.push(null);
            }
          }
        }
      },
    },
  },
  methods: {
    getDate(date) {
      if (!date) return "";

      return moment(date).format("DD/MM/YYYY");
    },
    async getInitDropdownData() {
      const brands = await useJwt.get("listBrand");
      if (brands.data && brands.data.result) {
        this.brands = brands.data.result.map((item) => ({
          id: item.id,
          text: item.value,
        }));
      }
    },
    async getSmsTypeDropdownData(val) {
      const smsType = await useJwt.get(`smsType?type=${val}`);
      if (smsType.data && smsType.data.result) {
        this.smsType = smsType.data.result.map((item) => ({
          id: item.id,
          text: item.value,
        }));
      }
    },
    getData() {
      return {
        brandName: +this.brandName,
        content: this.content,
        countNumber: +this.countNumber,
        dateSend: this.dateSend.map((i) => {
          const date = i.trim();
          return date;
        }),
        endDate: this.endDate,
        frequency: +this.frequency,
        img: this.img,
        notifyTitle: this.notifyTitle,
        sendInDay: this.sendInDay,
        startDate: this.startDate,
        type: +this.type,
        listSdt: this.listSdt,
      };
    },
    setData(data) {
      this.brandName = data.brandId;
      this.content = data.content;
      this.description = data.description;
      this.countNumber = data.countNumber;
      this.frequency = data.campaignFrequence;
      this.dateSend = data.dateSend
          ? data.dateSend.replace("[", "").replace("]", "").split(",")
          : [];
      this.endDate = data.endDate;
      this.img = data.img ? data.img : null;
      this.notifyTitle = data.notifyTitle;
      this.sendInDay = data.sendInDay;
      this.startDate = data.startDate;
      this.type = data.typeId;
      this.listSdt = data.listNumber
          ? data.listNumber.replace("[", "").replace("]", "").split(",")
          : [];
      this.uploadUrl = data.picture;
      this.detailId = data.id;
      this.statusCancel = data.statusCancel
    },
    onUploadImage(e) {
      const file = e?.target?.files[0];
      if (file) {
        const reader = new FileReader();
        reader.addEventListener(
            "load",
            () => {
              this.uploadUrl = reader.result;
              this.img = reader.result;
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Upload ảnh thành công",
                  icon: "CheckSquareIcon",
                  variant: "success",
                },
              });
            },
            false
        );
        reader.readAsDataURL(file);
      }
      this.inputKey = uuidv4();
    },
    onLoadExcel(e) {
      if (e?.target?.files[0]) {
        readXlsxFile(e?.target?.files[0])
            .then((rows) => {
              this.listSdt = [];
              for (const row of rows) {
                if (row[0]) {
                  this.listSdt.push(row[0]);
                }
              }
              this.fileName = e?.target?.files[0].name;
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Upload tệp thuê bao thành công",
                  icon: "CheckSquareIcon",
                  variant: "success",
                },
              });
            })
            .catch(() => {
              this.fileName = "";
            });
      }

      this.inputExcelKey = uuidv4();
    },
    downloadFile() {
      const data = {
        name: "FileSim",
        type: "xlsx",
        report: "FileSim",
        src: "web",
        parameter: {
          ID: this.detailId,
        },
      };

      useJwt.postDownload(`jasper`, "file.xlsx", data);
    },
  },
  data() {
    return {
      brands: [],
      uploadUrl: null,
      smsType: [],
      brandName: null,
      content: "",
      countNumber: 0,
      dateSend: [],
      endDate: null,
      frequency: null,
      img: null,
      notifyTitle: null,
      sendInDay: null,
      startDate: null,
      type: null,
      inputKey: uuidv4(),
      inputExcelKey: uuidv4(),
      listSdt: [],
      fileName: "",
      detailId: null,
      statusCancel: 0,
      description: ""
    };
  },
};
</script>
<style lang="scss" scoped>
.cancel-card {
  padding: 8px;
  width: fit-content;
  border-radius: 8px;
  position: absolute;
  top: 0;
  right: 50px;
  font-size: 1rem;
}
</style>
<style lang="scss">
.detail-form-container {
  width: 100%;
  background: white;
}

.detail-form-container legend {
  padding: 0 !important;
}

.upload-img {
  width: 120px;
  height: 120px;
  border: 1px solid gray;
}

.text-align-right {
  text-align: right;
}

.upload-file-btn {
  border-color: #ea5455 !important;
  background-color: #ea5455 !important;
  padding: 0.715rem 0.736rem;
  cursor: pointer;
  display: inline-block;
  font-weight: 400;
  color: #ffffff;
  vertical-align: middle;
  user-select: none;
  font-size: 1rem;
  line-height: 1;
  box-shadow: 0 8px 25px -8px #ea5455;
  border-radius: 5px;
}

.file-name {
  color: rgb(12, 81, 241);
  font-style: italic;
  font-weight: 600;
  width: fit-content;
  text-decoration: none;
}

.file-name:hover {
  color: rgb(26, 64, 154);
  font-weight: bolder;
  cursor: pointer;
  text-decoration: underline;
}
</style>
